import * as React from 'react';
import { useIntl } from 'react-intl';
import { useRecoilValue } from 'recoil';
import DynamicTable from '../DynamicTable';
import { IDynamicTableAddButton } from '../../interfaces/tables';
import { TABLE_AUTO_REPORT, TABLE_AUTO_REPORT_LOG } from '../../Services/TableService';
import TabComponent from '../TabComponent';
import { ITableFilter, setTableFilterAtom } from '../../store/recoil/TableState';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import OnlineHelp from '../OnlineHelp';
import { tabsByPermission } from './AutoReportService';

function AutoReportLogs(): JSX.Element {
  const tableFilter = useRecoilValue<ITableFilter | null>(setTableFilterAtom);
  const { formatMessage: f } = useIntl();

  const tabs = React.useState(
    tabsByPermission([TABLE_AUTO_REPORT, TABLE_AUTO_REPORT_LOG], TABLE_AUTO_REPORT_LOG)
  )[0];
  const documentTitle = `${f({ id: 'tab.auto-report/log' })} - ${f({
    id: 'menu.autoReports',
  })} - ${f({ id: 'menu.reports' })}`;
  useDocumentTitle(documentTitle);

  const buttons: IDynamicTableAddButton = {};

  return (
    <div>
      <div
        className="col-12"
        style={{
          display: '',
        }}
      >
        <div className="row section page-head">
          <h4>
            {`${f({ id: 'menu.reports' })} / ${f({ id: 'menu.autoReports' })}`}
            <OnlineHelp topic="auto-reports" />
          </h4>
        </div>
        <TabComponent tabs={tabs}>
          <div>
            <DynamicTable
              name={TABLE_AUTO_REPORT_LOG}
              mustClosed={true}
              buttons={buttons[TABLE_AUTO_REPORT_LOG]}
              filter={tableFilter}
            />
          </div>
        </TabComponent>
      </div>
    </div>
  );
}

export default AutoReportLogs;
